import { Tabs } from "shared/components/Tabs";

export const DepositTabs = ({
  companyName,
  activeTab,
  setActiveTab
}: {
  companyName?: string;
  activeTab: "CompanyDeposits" | "AllDeposits";
  setActiveTab: (value: "CompanyDeposits" | "AllDeposits") => void;
}) => {
  const tabsDisplayMap = {
    CompanyDeposits: (
      <p className="text-sm">{`${companyName || "Income source related"} deposits`}</p>
    ),
    AllDeposits: <p className="text-sm">View all deposits</p>
  };

  return (
    <Tabs
      variant="underline"
      tabs={["CompanyDeposits", "AllDeposits"]}
      displayMap={tabsDisplayMap}
      setActiveTab={(t) => setActiveTab(t)}
      selected={activeTab}
    />
  );
};
